export default __webpack_public_path__ + "static/media/HondaCA.9cca13bd.png";